let isTooltipInitialized = false;

export const tooltipInit = () => {
  const tooltip = document.getElementById('shareTooltip');
  const closeButton = tooltip?.querySelector('.share-tooltip__close');
  const inputTxt = tooltip?.querySelector('.share-tooltip__input-p');
  let activeButton = null;
  let tooltipWidth, tooltipHeight;
  let copyResetTimeout = null;
  let originalCopyIcon = null;
  let copyButton = null;

  if (!tooltip) return;

  if (inputTxt) inputTxt.style.display = 'block';

  // Инициализация размеров тултипа
  tooltip.style.display = 'block';
  tooltipHeight = tooltip.offsetHeight;
  tooltipWidth = tooltip.offsetWidth;
  tooltip.style.display = 'none';

  // Сохраняем первоначальную иконку копирования при инициализации
  copyButton = tooltip.querySelector('.share-tooltip__copy-btn');
  if (copyButton) {
    const svg = copyButton.querySelector('svg');
    if (svg) {
      originalCopyIcon = svg.innerHTML;
    }
  }

  // Добавляем global event listeners только один раз
  if (!isTooltipInitialized) {
    // Закрытие при клике вне тултипа (используем делегирование)
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.js-article-preview__share') &&
        !e.target.closest('.share-tooltip') &&
        tooltip?.style.display === 'block') {
        closeTooltip();
      }
    });

    // Обработка кнопок "Поделиться" через делегирование событий
    document.addEventListener('click', function (e) {
      const shareButton = e.target.closest('.js-article-preview__share');
      if (!shareButton) return;

      e.stopPropagation();

      // Закрытие при повторном клике
      if (activeButton === shareButton) {
        closeTooltip();
        return;
      }

      // Сбрасываем состояние кнопки копирования при каждом открытии модального окна
      resetCopyButton();

      // Получение данных
      const url = shareButton.dataset.url;

      // Проверяем, является ли URL уже полным
      const fullUrl = url.startsWith('http') ? url : `${window.location.origin}${url}`;

      const title = encodeURIComponent(shareButton.dataset.title || '');
      const encodedUrl = encodeURIComponent(fullUrl);

      const isMobile = window.matchMedia("(max-width: 768px)").matches;
      // Формирование ВСЕХ ссылок
      const links = {
        tg: `https://t.me/share/url?url=${encodedUrl}&text=${title}`,
        vk: `https://vk.com/share.php?url=${encodedUrl}&title=${title}`,
        ok: `https://connect.ok.ru/offer?url=${encodedUrl}&title=${title}`,
        x: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${title}`,
        fb: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
        rd: `https://reddit.com/submit?url=${encodedUrl}&title=${title}`,
        linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=${title}`,
        whatsapp: isMobile ? `https://api.whatsapp.com/send?text=${title}%20${encodedUrl}` : `https://web.whatsapp.com/send?text=${encodedUrl}`,
      };

      // Установка ссылок
      Object.keys(links).forEach(key => {
        const link = tooltip.querySelector(`.share-tooltip__link--${key}`);
        if (link) link.href = links[key];
      });

      // Настройка поля ввода
      const input = tooltip.querySelector('.share-tooltip__input');
      const inputTxt = tooltip?.querySelector('.share-tooltip__input-p');
      input.value = fullUrl;
      inputTxt.innerHTML = fullUrl;
      inputTxt.style.display = 'block'

      // Позиционирование
      positionTooltip(shareButton);
      tooltip.style.display = 'block';
      activeButton = shareButton;
    });

    isTooltipInitialized = true;
  }

  // Закрытие при клике на крестик (переинициализируем каждый раз)
  if (closeButton) {
    closeButton.removeEventListener('click', closeTooltip);
    closeButton.addEventListener('click', closeTooltip);
  }

  // Обработка копирования (переинициализируем каждый раз)
  if (copyButton) {
    copyButton.removeEventListener('click', handleCopyClick);
    copyButton.addEventListener('click', handleCopyClick);
  }

  // Функция обработки копирования
  function handleCopyClick() {
    const input = tooltip.querySelector('.share-tooltip__input');
    input.select();

    try {
      navigator.clipboard.writeText(input.value).then(() => {
        showCopySuccess(this);
      }).catch(() => {
        // Fallback для старых браузеров
        if (document.execCommand('copy')) {
          showCopySuccess(this);
        }
      });
    } catch (err) {
      // Fallback для старых браузеров
      if (document.execCommand('copy')) {
        showCopySuccess(this);
      }
    }
  }

  // Функция позиционирования
  function positionTooltip(button) {
    const rect = button.getBoundingClientRect();
    const scrollY = window.scrollY;
    const windowWidth = document.documentElement.clientWidth;
    const windowHeight = document.documentElement.clientHeight;

    // Расчет позиции по горизонтали

    let left = rect.left + rect.width / 2 - tooltipWidth / 2;
    left = windowWidth < left + tooltipWidth ? windowWidth - tooltipWidth - 20 : left;

    // Расчет позиции по вертикали
    let top = rect.bottom + scrollY + 20;
    const spaceBelow = windowHeight - rect.bottom;

    if (spaceBelow < tooltipHeight && rect.top > tooltipHeight) {
      top = rect.top + scrollY - tooltipHeight - 40;
    } else if (spaceBelow < tooltipHeight) {
      top = windowHeight + scrollY - tooltipHeight - 40;
    }

    tooltip.style.left = `${left}px`;
    tooltip.style.top = `${top}px`;

    if (window.innerWidth < 400) {
      tooltip.style.left = '10px'
      tooltip.style.right = '10px'
      tooltip.style.width = 'auto'
    }
  }

  // Функция сброса состояния кнопки копирования
  function resetCopyButton() {
    // Очищаем таймер если он активен
    if (copyResetTimeout) {
      clearTimeout(copyResetTimeout);
      copyResetTimeout = null;
    }

    // Восстанавливаем первоначальную иконку и убираем класс copied
    if (copyButton && originalCopyIcon) {
      const svg = copyButton.querySelector('svg');
      if (svg) {
        svg.innerHTML = originalCopyIcon;
      }
      copyButton.classList.remove('copied');
    }
  }

  // Функция закрытия тултипа
  function closeTooltip() {
    if (tooltip) {
      tooltip.style.display = 'none';
      activeButton = null;
    }
  }

  // Функция показа успешного копирования
  function showCopySuccess(button) {
    const svg = button.querySelector('svg');

    // Очищаем предыдущий таймер если он есть
    if (copyResetTimeout) {
      clearTimeout(copyResetTimeout);
    }

    // Меняем иконку на галочку
    svg.innerHTML = `
      <path d="M16.6666 5L7.49992 14.1667L3.33325 10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    `;

    // Добавляем класс для цвета успеха
    button.classList.add('copied');

    // Возвращаем обратно через 4 секунды
    copyResetTimeout = setTimeout(() => {
      resetCopyButton();
    }, 4000);
  }
};